import { Tag } from "@chef/components";

import { RecipeAndStepsQuery } from "@chef/state-management";
import { generateTags } from "@chef/state-management/helpers";

interface CampaignTagProps {
  recipe: RecipeAndStepsQuery["recipeAndSteps"];
}

export const CampaignTag = ({ recipe }: CampaignTagProps) => {
  const { campaign } = generateTags(recipe);

  if (!campaign?.text) {
    return null;
  }

  return (
    <Tag white className="normal-case">
      <div className="mr-2 circle bg-highlight" />
      <p>{campaign?.text}</p>
    </Tag>
  );
};
